import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SubHeaderService } from '../services/subheader.service';
import { BackButtonDirective } from '../../shared/directives/back-button.directive';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-subheader',
    templateUrl: './subheader.component.html',
    styleUrls: ['./subheader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BackButtonDirective, TranslateModule]
})
export class SubheaderComponent {
  private subHeaderService = inject(SubHeaderService);

  protected title = toSignal(this.subHeaderService.title, { initialValue: '' });
  protected subTitle = toSignal(this.subHeaderService.subTitle, { initialValue: '' });
}
